import DocumentDetails from "../GridDataComponent/DocumentDetails";
import "../../CriminalCertificateValidation.css";

const Bank = () =>{
 return(
<DocumentDetails documentType={'bank-cheques'} keyAccess={'HawkAI-BankCheque'} title={'Bank Cheque'} exportDataToExcelName={'Bank Document'} analysefrom={'bank-cheque'} deleteText={'bank-cheque'} modelName={'doc-ai'} webSocketName = {'bankcheque'}/>
 )
};
export default Bank;